import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
// import logo from "../Images/Nutrinest Logo1.jpeg";
import logo from "../Images/Nutrinest Logo.png";

import {
  Navbar,
  NavDropdown,
  Nav,
  Container,
  Button,
  Image,
  Offcanvas
} from "react-bootstrap";

import "./Navbar1.css";

function BasicExample() {
  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleNavClick = () => {
    setExpanded(false);
  };

  return (
    <Navbar
      expand="xl"
      expanded={expanded}
      onToggle={setExpanded}
      className={`custom-navbar ${scrolled ? "scrolled" : ""}`}
    >
      <Container fluid>

        {/* Logo */}
        <Navbar.Brand
          as={NavLink}
          to="/"
          onClick={handleNavClick}
          className="brand-section"
        >
          <Image
            src={logo}
            alt="logo"
            className="brand-logo"
            rounded
          />
        </Navbar.Brand>

        {/* Mobile Toggle */}
        <Navbar.Toggle />

        {/* Desktop + Mobile Menu */}
        <Navbar.Offcanvas placement="end">

          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              <Image
                src={logo}
                alt="logo"
                height={90}
                roundedCircle
              />
            </Offcanvas.Title>
          </Offcanvas.Header>

          <Offcanvas.Body>

            {/* Center Menu */}
            <Nav className="nav-pill mx-auto">

              <Nav.Link
                as={NavLink}
                to="/"
                onClick={handleNavClick}
              >
                Home
              </Nav.Link>

              <Nav.Link
                as={NavLink}
                to="/about"
                onClick={handleNavClick}
              >
                About
              </Nav.Link>

              <Nav.Link
                as={NavLink}
                to="/blogs"
                onClick={handleNavClick}
              >
                Blogs
              </Nav.Link>

              
              <Nav.Link
                as={NavLink}
                to="/plans"
                onClick={handleNavClick}
              >
                Plans
              </Nav.Link>

              {/* <NavDropdown title="Services">

                <NavDropdown.Item as={NavLink} to="/NutritionalAssessment" onClick={handleNavClick}>
                  Nutritional Assessment
                </NavDropdown.Item>

                <NavDropdown.Item as={NavLink} to="/MealPlanning" onClick={handleNavClick}>
                  Meal Planning
                </NavDropdown.Item>

                <NavDropdown.Item as={NavLink} to="/MedicalNutritionTherapy" onClick={handleNavClick}>
                  Medical Nutrition Therapy
                </NavDropdown.Item>

                <NavDropdown.Item as={NavLink} to="/WeightManagement" onClick={handleNavClick}>
                  Weight Management
                </NavDropdown.Item>

              </NavDropdown> */}

              <Nav.Link
                as={NavLink}
                to="/contact"
                onClick={handleNavClick}
              >
                Contact
              </Nav.Link>

            </Nav>

            {/* Buttons */}
            {/* Right Side Buttons */}
            <div className="nav-icons">

              {/* <Button as={NavLink} to="/plans" onClick={handleNavClick} className="nav-btn">
                  Plans
                </Button> */}

              {/* <div className="button-row">
                <Button as={NavLink} to="/NutritionProgram" onClick={handleNavClick} className="nav-btn">
                  Nutrition Program
                </Button>

                <Button as={NavLink} to="/Consultation" onClick={handleNavClick} className="nav-btn">
                  Online Consultation
                </Button>
              </div>

              <div className="button-row">
                <Button as={NavLink} to="/DietPlan" onClick={handleNavClick} className="nav-btn">
                  Diet Plan
                </Button>

                <Button as={NavLink} to="/PCOD" onClick={handleNavClick} className="nav-btn">
                  PCOS/PCOD Warriors
                </Button>
              </div> */}

            </div>

          </Offcanvas.Body>

        </Navbar.Offcanvas>

      </Container>
    </Navbar>
  );
}

export default BasicExample;